
export const PROJECTTYPE = Object.freeze({
    FULLSTACK:  "fullstack",
    BACKEND: "backend",
    FRONTEND: "frontend",
    CREATIVE: "creative",
});